import React from 'react';

interface MerchandiseIconProps {
  className?: string;
  size?: number;
}

/**
 * Ícono de "Mercancía"
 * 
 * DESCRIPCIÓN VISUAL:
 * - Un carrito de compras o carretilla
 * - Forma de cesta rectangular con asa en la parte superior
 * - Dos ruedas en la parte inferior (círculos)
 * - Puede tener líneas internas que sugieren el contenido
 * - Representa mercancía, productos en carrito o inventario móvil
 * - Estilo minimalista, líneas limpias
 * - Similar a un carrito de supermercado o carretilla industrial
 * 
 * Usa currentColor para adaptarse automáticamente al tema light/dark
 */
export const MerchandiseIcon: React.FC<MerchandiseIconProps> = ({
  className = '',
  size = 150,
}) => {
  return (
    <svg
      width={size}
      height={(size * 134) / 150}
      viewBox="0 0 150 134"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M0 2.57812C0 1.43516 0.9375 0.5 2.08333 0.5H14.5833C20.3385 0.5 25 5.1498 25 10.8906V98.1719C25 103.913 29.6615 108.562 35.4167 108.562H147.917C149.062 108.562 150 109.498 150 110.641C150 111.784 149.062 112.719 147.917 112.719H134.323C136.302 114.927 137.5 117.836 137.5 121.031C137.5 127.915 131.901 133.5 125 133.5C118.099 133.5 112.5 127.915 112.5 121.031C112.5 117.836 113.698 114.927 115.677 112.719H59.3229C61.3021 114.927 62.5 117.836 62.5 121.031C62.5 127.915 56.901 133.5 50 133.5C43.099 133.5 37.5 127.915 37.5 121.031C37.5 117.836 38.6979 114.927 40.6771 112.719H35.4167C27.3698 112.719 20.8333 106.199 20.8333 98.1719V10.8906C20.8333 7.43574 18.0469 4.65625 14.5833 4.65625H2.08333C0.9375 4.65625 0 3.72109 0 2.57812ZM125 112.719C120.391 112.719 116.667 116.433 116.667 121.031C116.667 125.629 120.391 129.344 125 129.344C129.609 129.344 133.333 125.629 133.333 121.031C133.333 116.433 129.609 112.719 125 112.719ZM41.6667 121.031C41.6667 125.629 45.3906 129.344 50 129.344C54.6094 129.344 58.3333 125.629 58.3333 121.031C58.3333 116.433 54.6094 112.719 50 112.719C45.3906 112.719 41.6667 116.433 41.6667 121.031ZM81.25 21.2812H52.0833C48.6198 21.2812 45.8333 24.0607 45.8333 27.5156V81.5469C45.8333 85.0018 48.6198 87.7812 52.0833 87.7812H81.25C84.7135 87.7812 87.5 85.0018 87.5 81.5469V27.5156C87.5 24.0607 84.7135 21.2812 81.25 21.2812ZM91.6667 44.1406C93.4115 42.8418 95.5729 42.0625 97.9167 42.0625H122.917C128.672 42.0625 133.333 46.7123 133.333 52.4531V81.5469C133.333 87.2877 128.672 91.9375 122.917 91.9375H97.9167C94.5052 91.9375 91.4844 90.301 89.5833 87.7812C87.6823 90.301 84.6615 91.9375 81.25 91.9375H52.0833C46.3281 91.9375 41.6667 87.2877 41.6667 81.5469V27.5156C41.6667 21.7748 46.3281 17.125 52.0833 17.125H81.25C87.0052 17.125 91.6667 21.7748 91.6667 27.5156V44.1406ZM91.6667 52.4531V81.5469C91.6667 85.0018 94.4531 87.7812 97.9167 87.7812H122.917C126.38 87.7812 129.167 85.0018 129.167 81.5469V52.4531C129.167 48.9982 126.38 46.2188 122.917 46.2188H97.9167C94.4531 46.2188 91.6667 48.9982 91.6667 52.4531Z"
        fill="currentColor"
      />
    </svg>
  );
};

